import { css } from "@compiled/react";

export const UniformMissingComponent = ({
    componentName
}: {
    componentName: string;
}) => {
    return (
        <span
            css={css({
                display: "none"
            })}
            id={`UNIFORM-MISSING-COMPONENT-${componentName}`}
            data-nosnippet // Hide from search engines
            aria-hidden // Hide from screen readers
        />
    );
};
